import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import Close from '@icon/Close';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';

const Container = styled.div`
  width: 314px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  flex-direction: column;
  padding: ${Spacings.SPACING_5B} ${Spacings.SPACING_6B};
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
`;

const TopRow = styled.div``;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledH5 = styled(H5)`
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const StyledP2 = styled(P2)`
  margin-top: ${Spacings.SPACING_2B};
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const StyledButton = styled(Button)`
  margin-top: ${Spacings.SPACING_6B};
  width: 122px;
  height: 38px;
`;

const StyledClose = styled(Close)`
  cursor: pointer;
  position: absolute;
  right: ${Spacings.SPACING_6B};
  top: ${Spacings.SPACING_6B};
`;

const TopBorder = styled.div`
  margin-bottom: -${Spacings.SPACING_2B};
  height: 12px;
  background-color: ${({ theme }) => theme.colors.orange};
  border-top-left-radius: ${Spacings.SPACING_2B};
  border-top-right-radius: ${Spacings.SPACING_2B};
`;

const IconContainer = styled.div`
  width: 100%;
  margin-bottom: ${Spacings.SPACING_4B};
`;

const Icon = styled.img``;

const NudgeCard = ({
  title,
  description,
  buttonText,
  onActionClick,
  onCloseClick,
  icon
}) => {
  const theme = useContext(ThemeContext);
  const titles = title.split(':');
  if (titles.length > 1) {
    titles[0] += ': ';
  }

  return (
    <>
      <TopBorder />
      <Container>
        <TopRow>
          {icon && (
            <IconContainer>
              <Icon src={icon} alt="icon" />
            </IconContainer>
          )}
          <StyledClose
            size="24px"
            onClick={onCloseClick}
            color={theme.colors.fontGrey}
          />
          <Column>
            {titles.map((item, index) => (
              <StyledH5 key={String(index)}>{item}</StyledH5>
            ))}
          </Column>
        </TopRow>
        <StyledP2>{description}</StyledP2>
        <StyledButton label={buttonText} onClick={onActionClick} />
      </Container>
    </>
  );
};

NudgeCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  icon: PropTypes.string
};

NudgeCard.defaultProps = {
  icon: ''
};

export default NudgeCard;
